// Imports remain the same
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  TextField,
  Chip,
  Radio,
  RadioGroup,
  FormControlLabel,
  MenuItem,
  Select,
  IconButton,
  Divider,
} from "@mui/material";
import locationIcon from "../../assets/Icons/location-round.svg"
import anime from "../../assets/anime/success.json";

import CloseOutlined from "@mui/icons-material/CloseOutlined";


import { FloridaZipCodes } from "../../assets/Data/FloridaZipCodes";
import { useLazyQuery, useMutation } from "@apollo/client";
import { ADD_TO_WAITLIST, ADD_TO_ACTIVELIST } from "../../Utils/Mutations";
import { GET_PRODUCT_ORIGIN, GET_CATEGORIES_N_SUB } from "../../Utils/Queries";

import LottieWrapper from "./LottieWrapper";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { lg: 400, md: 400, sm: 400, xs: 300 },
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  zIndex: 1000,
  borderRadius: "8px",
  maxHeight: "90vh",
  overflowY: "auto",
};

const API_KEY = process.env.REACT_APP_GOOGLE_KEY;

const PostalCode = () => {
  const userLocation = JSON.parse(localStorage.getItem("postalCode"));
  const [open, setOpen] = useState(false);
  const [postalCode, setPostalCode] = useState("");
  const [placeName, setPlaceName] = useState("");
  const [isInFlorida, setIsInFlorida] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [countries, setCountries] = useState([]);
  const [category, setCategories] = useState([]);

  const [form, setForm] = useState({
    zipCode: "",
    Interested: "",
    description: "",
    country: "",
    categories: [],
    email: "",
    currentSpend: "",
    preferredSpend: "",
  });

  const [submitWaitlist] = useMutation(ADD_TO_WAITLIST);
  const [submitActivelist] = useMutation(ADD_TO_ACTIVELIST);

  const [getCountries, { loading, error, data: countryData }] =
    useLazyQuery(GET_PRODUCT_ORIGIN);
  const [
    getCategories,
    { loading: categoryLoad, error: categoryErr, data: categoryData },
  ] = useLazyQuery(GET_CATEGORIES_N_SUB);

  useEffect(() => {
    if (countryData) {
      setCountries(countryData?.getProductOrigins?.items);
    }
  }, [countryData]);

  useEffect(() => {
    if (categoryData) {
      setCategories(categoryData?.fetchAllCategoriesAndTheirSubCategories);
    }
  }, [categoryData]);

  useEffect(() => {
    if (!categoryData) getCategories();
    if (!countryData) getCountries();
  }, []);

  useEffect(() => {
    if (userLocation) {
      setPlaceName(userLocation);
    } else {
      setOpen(true);
    }
  }, [userLocation]);

  const checkZipCode = () => {
    if (FloridaZipCodes.includes(postalCode)) {
      handleSubmitActiveList();
      setIsInFlorida(true);
      localStorage.setItem("isInFlorida", JSON.stringify(true));
      setOpen(false);
    } else {
      setIsInFlorida(false);
      localStorage.setItem("isInFlorida", JSON.stringify(false));
      setForm((prev) => ({ ...prev, zipCode: postalCode }));
      setStep(1);
    }
  };

  const handlePostalCodeSubmit = async (e) => {
    e.preventDefault();
    setIsError(false);
    setIsLoading(true);
    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${postalCode}&key=${API_KEY}`,
      );
      const data = await res.json();
      // setIsLoading(false);
      if (data.results.length > 0) {
        const { formatted_address } = data.results[0];
        localStorage.setItem("postalCode", JSON.stringify(formatted_address));
        setPlaceName(formatted_address);
        checkZipCode();
      } else {
        setIsError(true);
      }
    } catch {
      setIsLoading(false);
      setIsError(true);
    }
  };

  const handleSubmitActiveList = async () => {
    try {
      const res = await submitActivelist({
        variables: {
          zipCode: postalCode,
        },
      });
      if (res) {
        setOpen(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmitForm = async () => {
    try {
      const res = await submitWaitlist({
        variables: {
          ...form,
        },
      });
      if (res) {
        setOpen(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleNext = () => {
    if (form.Interested === "NO") {
      setOpen(false);
    } else {
      setStep((prev) => prev + 1);
    }
  };

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <Box sx={{ padding: 2 }}>
            <img
              src="/not-in-zip.png"
              alt="City Survey"
              style={{
                width: "100%",
                borderRadius: 8,
              }}
            />
            <Typography
              sx={{ color: "#151515", fontWeight: 500, fontSize: 20 }}
            >
              Would you like Mamaket to be available in your city?
            </Typography>

            <Box
              sx={{
                width: "70%",
                mx: "auto",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Button
                variant="outlined"
                sx={{
                  marginY: 1,
                  padding: 1,
                  px: 3,
                  borderRadius: 2,
                }}
                onClick={() => setOpen(false)}
              >
                Close
              </Button>
              <Button
                variant="contained"
                sx={{
                  marginY: 1,
                  padding: 1,
                  background: "#f1f1f1",
                  borderRadius: 2,
                  px: 3,
                  color: "primary.main",
                }}
                onClick={handleNext}
              >
                Next
              </Button>
            </Box>
          </Box>
        );
      case 2:
        return (
          <Box sx={{ padding: 2 }}>
            <RadioGroup
              value={form.Interested}
              onChange={(e) => setForm({ ...form, Interested: e.target.value })}
            >
              <FormControlLabel
                sx={{
                  fontSize: 16,
                  padding: 1,
                  border: 1,
                  marginY: 1,
                  borderColor: "#999",
                  borderRadius: 3,
                }}
                value="YES"
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel
                sx={{
                  fontSize: 16,
                  padding: 1,
                  border: 1,
                  marginY: 1,
                  borderColor: "#999",
                  borderRadius: 3,
                }}
                value="NO"
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
            <Button
              sx={{
                marginY: 1,
                padding: 1,
                background: "#f1f1f1",
                borderRadius: 2,
              }}
              disabled={!form.Interested}
              onClick={handleNext}
            >
              Next
            </Button>
          </Box>
        );
      case 3:
        return (
          <Box sx={{ padding: 2 }}>
            <Typography
              sx={{ color: "#151515", fontWeight: 500, fontSize: 20 }}
            >
              What best describes you?
            </Typography>
            <RadioGroup
              value={form.description}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
            >
              <FormControlLabel
                sx={{
                  fontSize: 16,
                  padding: 1,
                  border: 1,
                  marginY: 1,
                  borderColor: "#999",
                  borderRadius: 3,
                }}
                value="BUYER"
                control={<Radio />}
                label="Buyer"
              />
              <FormControlLabel
                sx={{
                  fontSize: 16,
                  padding: 1,
                  border: 1,
                  marginY: 1,
                  borderColor: "#999",
                  borderRadius: 3,
                }}
                value="SELLER"
                control={<Radio />}
                label="Seller"
              />
              <FormControlLabel
                sx={{
                  fontSize: 16,
                  padding: 1,
                  border: 1,
                  marginY: 1,
                  borderColor: "#999",
                  borderRadius: 3,
                }}
                value="SERVICE_PROVIDER"
                control={<Radio />}
                label="Service Provider"
              />
            </RadioGroup>
            <Button
              sx={{
                marginY: 1,
                padding: 1,
                background: "#f1f1f1",
                borderRadius: 2,
              }}
              disabled={!form.description}
              onClick={handleNext}
            >
              Next
            </Button>
          </Box>
        );
      case 4:
        return (
          <Box sx={{ padding: 2 }}>
            <Typography
              sx={{
                color: "#151515",
                fontWeight: 500,
                fontSize: 20,
                mb: 2,
                textAlign: "center",
                lineHeight: "22px",
              }}
            >
              Which country’s cultural items are you most interested in?
            </Typography>
            <Select
              value={form.country}
              onChange={(e) => setForm({ ...form, country: e.target.value })}
              fullWidth
            >
              {countries.map((item, index) => {
                return (
                  <MenuItem key={index} value={item._id}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
            <Button
              sx={{
                marginY: 1,
                padding: 1,
                background: "#f1f1f1",
                borderRadius: 2,
              }}
              disabled={!form.country}
              onClick={handleNext}
            >
              Next
            </Button>
          </Box>
        );
      case 5:
        return (
          <Box sx={{ padding: 2 }}>
            <Typography
              sx={{ color: "#151515", fontWeight: 500, fontSize: 20 }}
            >
              Select 3 categories
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
              {category?.map((item, index) => (
                <Chip
                  key={index}
                  label={item.category.name}
                  clickable
                  variant={
                    form.categories.includes(item.category._id)
                      ? "filled"
                      : "outlined"
                  }
                  color={
                    form.categories.includes(item.category._id)
                      ? "primary"
                      : "default"
                  }
                  onClick={() => {
                    setForm((prev) => {
                      const exists = prev.categories.includes(
                        item.category._id,
                      );
                      let updated = exists
                        ? prev.categories.filter((c) => c !== item.category._id)
                        : [...prev.categories, item.category._id];
                      return { ...prev, categories: updated.slice(0, 3) };
                    });
                  }}
                />
              ))}
            </Box>
            <Divider sx={{ mt: 2 }} />
            <Button
              sx={{
                marginY: 1,
                padding: 1,
                background: "#f1f1f1",
                borderRadius: 2,
              }}
              disabled={form.categories.length < 3}
              onClick={handleNext}
            >
              Next
            </Button>
          </Box>
        );
      case 6:
        return (
          <Box sx={{ padding: 2 }}>
            <Typography
              sx={{ color: "#151515", fontWeight: 500, fontSize: 20, mb: 1 }}
            >
              Preferred Email Address?
            </Typography>
            <TextField
              fullWidth
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="example@email.com"
            />
            <Button
              sx={{
                marginY: 1,
                padding: 1,
                background: "#f1f1f1",
                borderRadius: 2,
              }}
              disabled={!/^\S+@\S+\.\S+$/.test(form.email)}
              onClick={handleNext}
            >
              Next
            </Button>
          </Box>
        );
      case 7:
        return (
          <Box sx={{ padding: 2 }}>
            <Typography
              sx={{ color: "#151515", fontWeight: 500, fontSize: 20 }}
            >
              How much do you currently spend on cultural items?
            </Typography>
            <RadioGroup
              value={form.currentSpend}
              onChange={(e) =>
                setForm({ ...form, currentSpend: e.target.value })
              }
            >
              {["$10-$49", "$50-$99", "$100-$999", "$1000-Above"].map((v) => (
                <FormControlLabel
                  sx={{
                    fontSize: 16,
                    padding: 1,
                    border: 1,
                    marginY: 1,
                    borderColor: "#999",
                    borderRadius: 3,
                  }}
                  key={v}
                  value={v}
                  control={<Radio />}
                  label={v}
                />
              ))}
            </RadioGroup>
            <Button
              sx={{
                marginY: 1,
                padding: 1,
                background: "#f1f1f1",
                borderRadius: 2,
              }}
              disabled={!form.currentSpend}
              onClick={handleNext}
            >
              Next
            </Button>
          </Box>
        );
      case 8:
        return (
          <Box sx={{ padding: 2 }}>
            <Typography
              sx={{ color: "#151515", fontWeight: 500, fontSize: 20 }}
            >
              How much would you prefer to spend on cultural items?
            </Typography>
            <RadioGroup
              value={form.preferredSpend}
              onChange={(e) =>
                setForm({ ...form, preferredSpend: e.target.value })
              }
            >
              {["$10-$49", "$50-$99", "$100-$999", "$1000-$1,999"].map((v) => (
                <FormControlLabel
                  sx={{
                    fontSize: 16,
                    padding: 1,
                    border: 1,
                    marginY: 1,
                    borderColor: "#999",
                    borderRadius: 3,
                  }}
                  key={v}
                  value={v}
                  control={<Radio />}
                  label={v}
                />
              ))}
            </RadioGroup>
            <Button
              sx={{
                marginY: 1,
                padding: 1,
                background: "#f1f1f1",
                borderRadius: 2,
              }}
              disabled={!form.preferredSpend}
              onClick={handleNext}
            >
              Next
            </Button>
          </Box>
        );
      case 9:
        return (
          <Box sx={{ padding: 2 }}>
            <LottieWrapper animationData={anime} loop={false} height={80} />
            <Typography
              sx={{
                color: "#151515",
                fontWeight: 500,
                fontSize: 20,
                textAlign: "center",
              }}
              variant="h6"
              fontWeight={600}
            >
              Thank you
            </Typography>
            <Typography variant="body2" sx={{ textAlign: "center" }}>
              We appreciate you taking the time. We’re using your input to bring
              Mamaket closer to you.
            </Typography>
            <Button
              sx={{
                marginY: 2,
                padding: 1,
                background: "#f1f1f1",
                borderRadius: 2,
              }}
              fullWidth
              onClick={handleSubmitForm}
            >
              Done
            </Button>
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Box onClick={() => !userLocation && setOpen(true)}>
        <div className="flex items-center gap-x-2">
       <img src={locationIcon} alt="location" className="w-5 h-5"/>
          <div>
            <span className="truncate text-[#ffffff] text-[12px] font-[500]">
              {placeName}
            </span>
            <Typography
              sx={{
                color: "#fff",
                textDecoration: "underline",
                cursor: "pointer",
                fontSize: "10px",
              }}
              onClick={() => setOpen(true)}
            >
              Change Location
            </Typography>
          </div>
        </div>
      </Box>
      <Modal open={open}>
        <Box sx={style}>
          {step > 0 && (
            <Box align="right">
              <IconButton onClick={() => setOpen(false)}>
                <CloseOutlined sx={{ color: "#000" }} />
              </IconButton>
            </Box>
          )}
          {step === 0 ? (
            <Box>
              <Typography variant="h6">Enter your location</Typography>
              <Typography variant="body2">
                Find local products near you. Enter your zipcode.
              </Typography>
              <TextField
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handlePostalCodeSubmit(e);
                  }
                }}
                value={postalCode}
                onChange={(e) => setPostalCode(e.target.value)}
                placeholder="Zip Code"
                sx={{ mt: 2 }}
              />
              {isError ? (
                <span style={{ color: "red" }}>Invalid zip code</span>
              ) : (
                ""
              )}
              <Button
                fullWidth
                sx={{ mt: 2 }}
                variant="contained"
                loading={isLoading && !isError}
                onClick={handlePostalCodeSubmit}
              >
                Check
              </Button>
            </Box>
          ) : (
            renderStepContent()
          )}
        </Box>
      </Modal>
    </>
  );
};

export default PostalCode;
